const MessageMediaGrid = (message) => {
    const hasFiles = message.message_content?.files?.length > 0;
    const isFTM = message.message_sender?.user_type === "FTM";

    const filesLength = message.message_content?.files?.length || 0;

    const imageGridStyle = {
        display: "grid",
        gridTemplateColumns:
            filesLength === 1
                ? "1fr"
                : filesLength === 2
                ? "repeat(2, 1fr)"
                : "repeat(3, 1fr)",
        gap: "6px",
        marginTop: "6px",
    };

    const imageStyle = {
        width: "100%",
        height: "100px",
        objectFit: "cover",
        borderRadius: "8px",
        cursor: "pointer",
    };

    return {
        hasFiles,
        isFTM,
        imageGridStyle,
        imageStyle
    };
};

export default MessageMediaGrid;